import { Outlet, ScrollRestoration } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Layout = () => {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: "var(--mc-bg)", color: "var(--mc-ink)" }}
      data-testid="site-layout"
    >
      <ScrollToTop />
      <Nav />
      <main className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
